/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ClientWorkspaceInviteLogControlllerCancelInvite$Params {

/**
 * 고객사 ID
 */
  id: string;

/**
 * 초대 ID
 */
  inviteId: string;
}

export function clientWorkspaceInviteLogControlllerCancelInvite(http: HttpClient, rootUrl: string, params: ClientWorkspaceInviteLogControlllerCancelInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceInviteLogControlllerCancelInvite.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('inviteId', params.inviteId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

clientWorkspaceInviteLogControlllerCancelInvite.PATH = '/api/clientWorkspaceInviteLog/{id}/invite/{inviteId}/cancel';
